import { Connection } from "@/lib/types/unified";
import {
  connectionMatchesEmailProviders,
  MANAGEABLE_EMAIL_PROVIDER_KEYS,
} from "@/lib/constants/email-providers";

/**
 * Shared utility functions for email connection filtering and management
 */

/**
 * Filter connections to only include email providers (Gmail, Outlook, WTC Email).
 * Delegates to the canonical email-provider matcher, which normalizes the raw
 * legacy provider-template slug ("outlook") to its config key ("outlook-oauth").
 */
export function getEmailConnections(connections: Connection[]): Connection[] {
  return connections.filter((conn) =>
    connectionMatchesEmailProviders(conn, MANAGEABLE_EMAIL_PROVIDER_KEYS)
  );
}

/**
 * Check if a bare provider slug is an email provider.
 */
export function isEmailProvider(provider: string): boolean {
  return connectionMatchesEmailProviders({ provider }, MANAGEABLE_EMAIL_PROVIDER_KEYS);
}

/**
 * Get the display name for an email provider
 */
export function getEmailProviderDisplayName(provider: string): string {
  switch (provider) {
    case "google-mail":
      return "Gmail";
    case "outlook":
    case "outlook-oauth":
      return "Microsoft Outlook";
    case "professional-email":
      return "WTC Email";
    default:
      return provider;
  }
}
